import "./EmptyState.css";

import PropTypes from "prop-types";
import React from "react";

// Empty state: what a list or section shows when there is nothing to display.
// icon = FontAwesome class string, title = main line, text = optional help line,
// children = optional actions under the text.
export const EmptyState = ({ icon, title, text, children }) => (
  <div className="empty-state">
    {icon && <i className={`${icon} empty-state__icon`} />}
    <p className="empty-state__title">{title}</p>
    {text && <p className="empty-state__text">{text}</p>}
    {children && <div className="empty-state__actions">{children}</div>}
  </div>
);

EmptyState.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  children: PropTypes.node,
};
